import { definePreset } from '@primevue/themes'
import Lara from '@primevue/themes/lara'

export default {
  preset: definePreset(Lara, {}),
  options: {
    cssLayer: {
      name: 'primevue',
      order: 'reset, tailwind, primevue, primevue-overrides'
    },
    darkModeSelector: false
  }
}
